export default {
    GCJ02_BD09(gd_lon, gd_lat) {
        let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
        let x = Number(gd_lon)
        let y = Number(gd_lat)
        let z = Number(Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi))
        let theta = Number(Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi))
        let bd_lon = Number(z * Math.cos(theta) + 0.0065)
        let bd_lat = Number(z * Math.sin(theta) + 0.006)
        return [parseFloat(bd_lon.toFixed(6)), parseFloat(bd_lat.toFixed(6))]
    },
    BD09_GCJ02(bd_lon, bd_lat) {
        let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
        let x = Number(bd_lon - 0.0065)
        let y = Number(bd_lat - 0.006)
        let z = Number(Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi))
        let theta = Number(Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi))
        let gd_lon = Number(z * Math.cos(theta))
        let gd_lat = Number(z * Math.sin(theta))
        return [parseFloat(gd_lon.toFixed(6)), parseFloat(gd_lat.toFixed(6))]
    },
    GetDistance(lng1, lat1, lng2, lat2) {
        const radLat1 = lat1 * Math.PI / 180.0;
        var radLat2 = lat2 * Math.PI / 180.0;
        var a = radLat1 - radLat2;
        var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
            Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * 6378.137;// EARTH_RADIUS;
        s = Math.round(s * 10000) / 10000;
        return s;
    }
}